import Cookies from 'universal-cookie';
import * as trueInitialState from "../store/trueInitialState";
import * as tools from "../helpers/Tools";

export function OurCookieStorage(cookies, options) {
    options = options || {};

    this.cookies = cookies;

    //debugger;
    this.persistSSO = options.persistSSO !== undefined ? Boolean(options.persistSSO) : false;
    this.persistSession = options.persistSession !== undefined ? Boolean(options.persistSession) : false;
    this.persistHeader = options.persistHeader !== undefined ? Boolean(options.persistHeader) : false;
    this.persistDashboard = options.persistDashboard !== undefined ? Boolean(options.persistDashboard) : false;
    this.persistHealthPlan = options.persistHealthPlan !== undefined ? Boolean(options.persistHealthPlan) : false;
    this.persistPharmacy = options.persistPharmacy !== undefined ? Boolean(options.persistPharmacy) : false;
    this.persistHealthSource = options.persistHealthSource !== undefined ? Boolean(options.persistHealthSource) : false;
    this.persistDomain = options.persistDomain !== undefined ? Boolean(options.persistDomain) : true;


    this.keyPrefix = options.keyPrefix || '';
    this.indexKey = options.indexKey || 'reduxPersistIndex';
    this.expiration = options.expiration || {};
    if (!this.expiration.default) {
        this.expiration.default = null;
    }

    this.setCookieOptions = options.setCookieOptions;
};

OurCookieStorage.prototype.getItem = function (key, callback) {

    var oRet;
    if (window.serverData.data.storageControllerV2) {
        try {
            if (key == "root") {
                var session = tools.getSessionItem(key, callback);
                var local = window.localStorage.getItem(key);
                var oLocal = JSON.parse(local);
                //oLocal.refreshToken = this.cookies.get("rt") || null;
                oRet = { ...JSON.parse(session), ...oLocal };
                //debugger;
                return Promise.resolve(JSON.stringify(oRet));
            }
            else {
                return Promise.resolve(tools.getSessionItem(key, callback));
            }

        }
        catch (e) {
            debugger;
        }

        //debugger;
        //return Promise.resolve(...tools.getSessionItem(key, callback));
    }

    //var frame = window.document.getElementById("frmStorage");
    ////debugger;

    //var win = getContentWindow(frame);
    //if (win && window.serverData.data.storageControllerV2) {
    //    return Promise.resolve( win.getSessionItem(key));
    //}

    var isClientSide = typeof window !== 'undefined';

    var item;
    var SSOItem = this.cookies.get(this.keyPrefix + key + "-SSO") || null;
    var SessionItem = this.cookies.get(this.keyPrefix + key + "-Session") || null;
    var HeaderItem = this.cookies.get(this.keyPrefix + key + "-Header") || null;
    var DomainItem = this.cookies.get(this.keyPrefix + key + "-Domain") || null;
    var oStartState = trueInitialState.trueInitialState;

    try {
        item = Object.assign(oStartState, SessionItem, SSOItem, HeaderItem, DomainItem);
    }
    catch (E) {
        console.error(E);
    }

    if (typeof self !== "undefined" && self["sessionStorage"][key]) {
        item = self["sessionStorage"][key];
    }

    if (callback) {
        callback(null, item);
    }

    return Promise.resolve(item);
};


OurCookieStorage.prototype.setItem = function (key, value, callback) {

    if (window.serverData.data.storageControllerV2) {
        //debugger;
        try {
            if (key == "root") {
                //debugger;
                var oJSON = JSON.parse(value);
                var oLocal = JSON.parse(oJSON.localStorage);
                //this.cookies.set("rt", oLocal.refreshToken, { domain: "bswhealth.com", path: "/" });
                //oLocal.refreshToken = null;

                window.localStorage.setItem(key, JSON.stringify({ localStorage: JSON.stringify( oLocal) }));

                oJSON.localStorage = null;
                value = JSON.stringify(oJSON);
            }
            return Promise.resolve(tools.setSessionItem(key, value, callback));
        }
        catch (e) {
            debugger;
        }
    }

    //    var frame = window.document.getElementById("frmStorage");
    ////    debugger;

    //    var win = getContentWindow(frame);
    //    if (win && window.serverData.data.storageControllerV2) {
    //        return Promise.resolve(win.setSessionItem(key, value));
    //    }

    // leave the cookie code as a fallback
    var options = Object.assign({}, this.setCookieOptions);
    var isClientSide = typeof window !== 'undefined';

    if (isClientSide) {
        //debugger;
        if (typeof self !== "undefined") self["sessionStorage"].setItem(key, value, callback);

        var oObject = JSON.parse(value);
        if (typeof oObject === "undefined") {
            //debugger; // I want to know when this fails to parse
            return;
        }

        var value2;
        var valueHeader;
        var valueDashboard;
        var valueHealthPlan;
        var valuePharmacy;
        var valueHealthSource;
        var valueDomain;
        if (oObject["domain"]) {
            try {
                //var ssoObject = oObject["sso"];
                //value = JSON.stringify({ sso: JSON.parse(oObject["sso"]) }); // Only want to duplicate SSO details into cookies right now
                //var sessionObject = oObject["session"];
                //value2 = JSON.stringify({ session: JSON.parse(sessionObject) });
                //var headerObject = oObject["header"];
                //valueHeader = JSON.stringify({ header: JSON.parse(headerObject) });
                //var dashboardObject = oObject["dashboard"];
                //valueDashboard = JSON.stringify({ dashboard: JSON.parse(dashboardObject) });
                //var healthplanObject = oObject["healthPlan"];
                //valueHealthPlan = JSON.stringify({ healthPlan: JSON.parse(healthplanObject) });
                //var pharmacyObject = oObject["pharmacy"];
                //valuePharmacy = JSON.stringify({ pharmacy: JSON.parse(pharmacyObject) });
                //var healthsourceObject = oObject["healthSource"];
                //valueHealthSource = JSON.stringify({ healthSource: JSON.parse(healthsourceObject) });
                //debugger;
                var domainObject = oObject["domain"];
                var oDomain = JSON.parse(domainObject);
                oDomain.ds = new Date();
                //debugger;

            }
            catch (E) {
                //debugger;
                console.error(E);
            }

            var expires = this.expiration.default;
            if (typeof this.expiration[key] !== 'undefined') {
                expires = this.expiration[key];
            }
            if (expires) {
                options["expires"] = expires;
            }

            //if (valueDomain.length > 3500) {
            //    //debugger; // stop here and figure this shit out
            //}
            //if (this.persistSSO) { this.cookies.set(this.keyPrefix + key + "-SSO", value, options); }
            //if (this.persistSession) { this.cookies.set(this.keyPrefix + key + "-Session", value2, options); }
            //if (this.persistHeader) { this.cookies.set(this.keyPrefix + key + "-Header", valueHeader, options); }
            //if (this.persistDashboard) { this.cookies.set(this.keyPrefix + key + "-Dashboard", valueDashboard, options); }
            //if (this.persistHealthPlan) { this.cookies.set(this.keyPrefix + key + "-HealthPlan", valueHealthPlan, options); }
            //if (this.persistPharmacy) { this.cookies.set(this.keyPrefix + key + "-Pharmacy", valuePharmacy, options); }
            //if (this.persistHealthSource) { this.cookies.set(this.keyPrefix + key + "-HealthSource", valueHealthSource, options); }
            if (this.persistDomain) {
                //debugger;
                // here we are attempting to compress the cookie size by swapping double quotes for single
                //valueDomain = valueDomain.replace(/\'/g, "\'").replace(/\"/g, "'");  <--- try to compress cookie size
                //debugger;
                this.cookies.expire(this.keyPrefix + key + "-Domain"); // <-- we do this as a "catch-all" for places the domain cookie is set without a domain
                oDomain["pl"] = null;
                oDomain["cm"] = null;
                valueDomain = JSON.stringify({ domain: oDomain });
                this.cookies.set(this.keyPrefix + key + "-Domain", valueDomain, options);
                let sCheckValue = this.cookies.get(this.keyPrefix + key + "-Domain");
                if (sCheckValue !== valueDomain) {
                    //debugger;
                }
            }
        }

        // Update key index
        var indexOptions = Object.assign({}, this.setCookieOptions);
        if (this.expiration.default) {
            indexOptions["expires"] = this.expiration.default;
        }
    }
    return this.getAllKeys().then(function (allKeys) {
        if (allKeys.indexOf(key) === -1) {
            allKeys.push(key);
            if (isClientSide) {
                this.cookies.set(this.indexKey, JSON.stringify(allKeys), indexOptions);
            }
        }
        if (callback) {
            callback(null);
        }
        return Promise.resolve(null);
    }.bind(this));
};




OurCookieStorage.prototype.removeItem = function (key, callback) {

    if (window.serverData.data.storageControllerV2) {
        if (key == "root") {
            this.cookies.remove("rt", { domain: "bswhealth.com", path: "/" });
            localStorage.removeItem(key);
        }
        return Promise.resolve(tools.removeSessionItem(key, callback));
    }

    //var frame = window.document.getElementById("frmStorage");
    ////debugger;

    //var win = getContentWindow(frame);
    //if (win && window.serverData.data.storageControllerV2) {
    //    return Promise.resolve(win.removeSessionItem(key));
    //}

    if (typeof self !== "undefined") self["sessionStorage"].removeItem(key);
    this.cookies.expire(this.keyPrefix + key);
    if (this.persistSSO) { this.cookies.expire(this.keyPrefix + key + "-SSO"); }
    if (this.persistSession) { this.cookies.expire(this.keyPrefix + key + "-Session"); }
    if (this.persistHeader) { this.cookies.expire(this.keyPrefix + key + "-Header"); }
    if (this.persistDashboard) { this.cookies.expire(this.keyPrefix + key + "-Dashboard"); }
    if (this.persistHealthPlan) { this.cookies.expire(this.keyPrefix + key + "-HealthPlan"); }
    if (this.persistPharmacy) { this.cookies.expire(this.keyPrefix + key + "-Pharmacy"); }
    if (this.persistHealthSource) { this.cookies.expire(this.keyPrefix + key + "-HealthSource"); }
    if (this.persistDomain) { this.cookies.expire(this.keyPrefix + key + "-Domain"); }

    return this.getAllKeys().then(function (allKeys) {
        allKeys = allKeys.filter(function (k) {
            return k !== key;
        });

        this.cookies.set(this.indexKey, JSON.stringify(allKeys));
        if (callback) {
            callback(null);
        }
        return Promise.resolve(null);
    }.bind(this));
};

OurCookieStorage.prototype.getAllKeys = function (callback) {
    var cookie = this.cookies[this.indexKey];

    var result = [];
    if (cookie) {
        result = JSON.parse(cookie);
    }

    if (callback) {
        callback(null, result);
    }
    return Promise.resolve(result);
};

//module.exports = OurCookieStorage